import TextBlock from "./TextBlock";

const NumberedListBlock = ({ block }) => {
  const content = block.content;
  return (
    <ol className="numbered-list-block">
      {content.map((item, index) => (
        <li key={`numbered-item-${index}`} className="numbered-list-item">
          <TextBlock block={item} />
        </li>
      ))}
    </ol>
  );
};

export default NumberedListBlock;